import React from "react"
import { Button, Tag } from "antd"
import { DeleteOutlined, CheckOutlined } from "@ant-design/icons"

export const getExperienceColumns = ({ t, onRemove }) => [
  {
    title: t("settings.column_name", "Experience Name"),
    dataIndex: "name",
    key: "name"
  },
  {
    title: t("settings.column_guests", "Guests"),
    dataIndex: "guests",
    key: "guests",
    align: "center"
  },
  {
    title: t("settings.column_price", "Price"),
    key: "price",
    align: "right",
    render: (_, record) => `$${record.price.toFixed(2)}`
  },
  {
    title: t("settings.column_status", "Status"),
    dataIndex: "status",
    key: "status",
    render: (status) => {
      const isPublished = String(status).toLowerCase() === "published"
      const displayText = String(status).charAt(0).toUpperCase() + String(status).slice(1)
      return (
        <Tag color={isPublished ? "green" : "default"} icon={isPublished ? <CheckOutlined /> : null}>
          {displayText}
        </Tag>
      )
    }
  },
  {
    title: "",
    key: "action",
    align: "right",
    render: (_, record) => (
      <Button
        type="text"
        icon={<DeleteOutlined />}
        onClick={() => onRemove(record.id)}
        aria-label="Remove experience"
      />
    )
  }
]
